module.exports = __webpack_public_path__ + "static/media/country_ck.9b51258b.webp";